// 2026-09-27 US-010
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LoyaltyCustomerDetailResponse, LoyaltyDashboardResponse } from 'common/models/LoyaltyTypes';
import { OperationStatus } from 'store/rootTypes';

const name = 'Loyalty';

interface ILoyaltyState {
  submitStatus: OperationStatus;
  Dashboard?: LoyaltyDashboardResponse;
  // The filter that was last SEARCHED, not whatever is typed in the box: paging always
  // re-queries with this so unsubmitted text is never applied.
  AppliedEmail: string;
  PageNumber: number;
  // Held here (persisted to sessionStorage with the root) instead of the URL, so the
  // customer identifier never lands in browser history or logs.
  SelectedCustomerKey?: string;
  CustomerDetail?: LoyaltyCustomerDetailResponse;
}

const initialState: ILoyaltyState = {
  submitStatus: OperationStatus.idle,
  Dashboard: undefined,
  AppliedEmail: '',
  PageNumber: 1,
  SelectedCustomerKey: undefined,
  CustomerDetail: undefined,
};

export const LoyaltySlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    SetDashboard: (state, action: PayloadAction<LoyaltyDashboardResponse | undefined>) => {
      state.Dashboard = action.payload;
    },
    SetQuery: (state, action: PayloadAction<{ AppliedEmail: string; PageNumber: number }>) => {
      state.AppliedEmail = action.payload.AppliedEmail;
      state.PageNumber = action.payload.PageNumber;
    },
    SetSelectedCustomerKey: (state, action: PayloadAction<string | undefined>) => {
      state.SelectedCustomerKey = action.payload;
    },
    SetCustomerDetail: (state, action: PayloadAction<LoyaltyCustomerDetailResponse | undefined>) => {
      state.CustomerDetail = action.payload;
    },
    submitStatus: (state) => handlePendingSubmitAction(state),
    submitStatusRejected: (state, action: PayloadAction<string>) => handleSubmitRejection(state, action),
    submitStatusSucceeded: (state) => {
      state.submitStatus = OperationStatus.succeeded;
    },
    resetSubmitStatus: (state) => {
      state.submitStatus = OperationStatus.idle;
    },
  },
});

const handlePendingSubmitAction = (state) => {
  state.submitStatus = OperationStatus.pending;
};

const handleSubmitRejection = (state, action: PayloadAction<string>) => {
  state.submitStatus = OperationStatus.failed;
  console.error(action.payload);
};

export const { actions: LoyaltyActions } = LoyaltySlice;

export default LoyaltySlice.reducer;
